import React, { useEffect, useState } from 'react';
import './sec-booking.css'
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import AddCTA from '../component/common/addcta';
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic28 from '../assets/pic28.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import { supabase } from '../supabase';
import Input from '../component/common/input';
import pic34 from '../assets/pic34.png'
import pic35 from '../assets/pic35.png'


const Usermangement = () => {



const [Users, setUsers] = useState([]);
const [showForm, setShowForm] = useState(false);
const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

const [formData, setFormData] = useState({
  user_name: '',
   user_name_ar: '',
  user_email: '',
    password: '',  
  Role: '',
  Role_ar: '',  
  profile: ''
});











useEffect(()=>{
    const getallBooking = async () =>{
        const res = await supabase.from ('Users').select('*');
        setUsers(res.data);

        console.log(res);
    }
    getallBooking();

},[])











const filteredUsers = Users
  .filter((item) => {
    const matchesSearch =
      (item.user_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.user_email?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.Role?.toLowerCase() || '').includes(search.toLowerCase());

    let matchesFilter = true;

    if (filter) {
      if (filter.startsWith('role')) {
        matchesFilter =
          item.Role?.toLowerCase() === filter.split('-')[1];
      }
    }

    return matchesSearch && matchesFilter;
  })

    





const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);
  setFormData({
    user_name: '',
    user_email: '',
    Role: '',
      profile: ''
  });
};


const createUser = async () => {
  const { error } = await supabase
    .from('Users')
    .insert([{
      user_name: formData.user_name,
        user_name_ar: formData.user_name_ar,
      user_email: formData.user_email,
        password: formData.password,
      Role: formData.Role,
        Role_ar: formData.Role_ar, 
      profile: formData.profile
    }]);

  if (error) {
    console.log("CREATE ERROR:", error);
    return;
  }

  const res = await supabase.from('Users').select('*');
  setUsers(res.data);
  handleClose();
};









const confirmDelete = async () => {
  const id = selectedDeleteId;

  await supabase.from('Feeback').delete().eq('user_id', id);
  await supabase.from('Booking').delete().eq('user_id', id);
  await supabase.from('Users').delete().eq('id', id);

  setUsers(prev => prev.filter(user => user.id !== id));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};






const handleEditClick = (item) => {
  setFormData({
    user_name: item.user_name || '',
      user_name_ar: item.user_name_ar || '',
    user_email: item.user_email || '',
      password: formData.password,
    Role: item.Role || '',
      Role_ar: item.Role_ar || '',  
    profile: item.profile || ''
  });

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};



const updateUser = async () => {
  const { error } = await supabase
    .from('Users')
    .update({
      user_name: formData.user_name,
        user_name_ar: formData.user_name_ar, 
      user_email: formData.user_email,
      Role: formData.Role,
        Role_ar: formData.Role_ar,    
      profile: formData.profile
    })
    .eq('id', editingId);

  if (error) {
    console.log("UPDATE ERROR:", error);
    return;
  }

  const res = await supabase.from('Users').select('*');
  setUsers(res.data);

  handleClose();
};


const ROLE_MAP = {
  Admin: 'مسؤول',
  User: 'مستخدم'
};




    return ( 

 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Users Management"  
                            para="Manage user accounts and permissions"
                            />
                          <AddCTA    title='Add User'   onClick={() => setShowForm(true)} />
                        
                        </article>



{showForm && (
  <div className="overlay-create">
    <div className="container-create">

      <div className="header-create">
            <h1 className="title-create">
            {isEditing ? 'Edit User' : 'Add New User'}
            </h1>

        <button
          className="close-btn-create"
          onClick={handleClose}
          type="button"
        >
          <img src={pic34} alt='close' />
        </button>
      </div>




      <form className="form-create"  onSubmit={(e) => {
                e.preventDefault();
            isEditing ? updateUser() : createUser();
            }}>

                                <fieldset className="field-group-create">
                                    <Input
                                        title='User Name'
                                        placeholder='Enter user name'
                                        type="text"
                                          value={formData.user_name}
                                        onChange={(e) =>
                                            setFormData({ ...formData, user_name: e.target.value })
                                        }
                                    />
                                </fieldset>

                                <fieldset className="field-group-create">
                                <Input
                                  title='User Name (Arabic)'
                                  placeholder='Enter Arabic name'
                                  type="text"
                                  value={formData.user_name_ar}
                                  onChange={(e) =>
                                    setFormData({ ...formData, user_name_ar: e.target.value })
                                  }
                                />
                              </fieldset>

                                <fieldset className="field-group-create">
                                      <Input
                                        title='User Email'
                                        placeholder='Enter user email'
                                        type="email"
                                        value={formData.user_email}
                                        onChange={(e) =>
                                          setFormData({ ...formData, user_email: e.target.value })
                                        }
                                      />
                                </fieldset>
                                <fieldset className="field-group-create">
                                     <Input
                                    title='Password'
                                    placeholder='Enter password'
                                    type="password"
                                    value={formData.password}
                                    onChange={(e) =>
                                      setFormData({ ...formData, password: e.target.value })
                                    }
                                  />
                                </fieldset>

                                <fieldset className="field-group-create">
                                  <fieldset className='container-text-area'>
                                    <h2 className="title-selecttt">Profile Image URL</h2>
                                    <input
                                      type="text"
                                      placeholder="Paste image URL here"
                                      value={formData.profile}
                                      onChange={(e) =>
                                        setFormData({ ...formData, profile: e.target.value })
                                      }
                                      className="input-search2"
                                    />

                                    {formData.profile && (
                                      <img
                                        src={formData.profile}
                                        alt="preview"
                                        className="preview-image-create"
                                      />
                                    )}
                                  </fieldset>
                                </fieldset>

                                      <fieldset className="fieldset">
                                        <label className='title-input'>Role</label>
                                        <div className="select-wrapper2">
                                          <img src={pic28} className="arrow-icon2" alt="arrow" />
                                          <select
                                            className="input-search2 select-style2"
                                            value={formData.Role}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({
                                              ...formData,
                                              Role: value,
                                              Role_ar: ROLE_MAP[value] 
                                            });
                                          }}
                                          >
                                            <option value="">Select Role</option>
                                            <option value="User">User</option>
                                            <option value="Admin">Admin</option>
                                          </select>
                                        </div>
                                      </fieldset>
                            
                                                        <nav className='container-ctas-craete'>
                                                                                    <button   type="button" className="cta-cancel-create" onClick={handleClose}>
                                                                                        <h2 className="cta-cancel-text-create">
                                                                                            Cancel
                                                                                        </h2>
                                                                                    </button>
                                                    
                                                                                    <button type="submit" className='cta-create'>
                                                                                    <h2 className='cta-create-text'>
                                                                                        {isEditing ? 'Edit User' : 'Add User'}
                                                                                    </h2>
                                                                                    </button>
                                                        </nav>
                                

      </form>
    </div>
  </div>
)}






{showDeleteModal && (
  <section className="delete-modal-overlay">
    <article className="delete-modal" role="dialog" aria-modal="true">
      
      <header className="delete-modal-header">
        <div className="delete-icon-wrapper">
          <img src={pic35} alt='icon'></img>
        </div>

        <div className="delete-text-container">
          <h2 className="delete-title">Delete User</h2>
          <p className="delete-description">
             Are you sure you want to delete this user? This action cannot be undone.
          </p>
        </div>
      </header>

      <nav className="delete-modal-actions">
        <button
          className="delete-btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setSelectedDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="delete-btn-confirm"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </nav>

    </article>
  </section>
)}






                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search for user..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>
                                      <option value="role-admin">Admin</option>
                                      <option value="role-user">User</option>
                                </select>
                                </div>
                            </fieldset>



                                                 <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>User name</th>
                                        <th className='table-header-text'>Email</th>
                                        <th className='table-header-text'>Password</th>
                                        <th className='table-header-text'>Role</th>
                                        <th className='table-header-text'>User name_ar</th>
                                        <th className='table-header-text'>Role_ar</th>
                                        <th className='table-header-text'>Actions</th>
                                    </tr>
                                    </thead>

 {filteredUsers.map((item) => { return <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox" />
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                 <td className='container-event-row'>
                                                    <img className='img-tabel-event2' src={item.profile} alt='pic'></img>
                                                    <div className='container-event2'>
                                                        <h2 className='event-title'>{item.user_name}</h2>
                                                    </div>
                                                </td>                                               
                                          <td className='mainwhite-table-font'>{item.user_email}</td>                                               
                                              <td className='mainwhite-table-font'>  {item.password}</td>  
                                                <td className='mainwhite-table-font'>{item.Role}</td>

                                                <td className='mainwhite-table-font_ar'>{item.user_name_ar}</td>
                                                <td className='mainwhite-table-font_ar'>{item.Role_ar}</td>

                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>
                                                            <button className='cta2-table'>
                                                                <img src={pic30} alt='hide'></img>
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => handleEditClick(item)}
                                                            >
                                                            <img src={pic31} alt='edit' />
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            >
                                                            <img src={pic32} alt='delete' />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
               })}
                                </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
        </section>

     );
}
 
export default Usermangement;